export default "__VITE_ASSET__CfH2$POw__"